"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// a basic component that includes a file input and the ability to render anything as the button.
// the input is accessed in the parent via the forwardedRef
var BasicPhotoInput = function BasicPhotoInput(_ref) {
  var handlePhotoSelect = _ref.handlePhotoSelect,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? true : _ref$multiple,
      forwardedRef = _ref.forwardedRef,
      _ref$renderButton = _ref.renderButton,
      renderButton = _ref$renderButton === void 0 ? function () {} : _ref$renderButton;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "basic-photo-input"
  }, renderButton(), /*#__PURE__*/_react.default.createElement("input", {
    className: "test",
    multiple: multiple,
    ref: forwardedRef,
    onChange: handlePhotoSelect,
    type: "file",
    accept: "image/png, image/jpg, image/jpeg, image/gif",
    style: {
      display: 'none'
    }
  }));
};

var _default = BasicPhotoInput;
exports.default = _default;